export default __webpack_public_path__ + "static/media/hombre1.6e8ee8b4.png";